export const SERVER_API_URL = 'https://microservice-dot-dev-splicer-204213.ey.r.appspot.com';
//export const SERVER_API_URL = 'http://localhost:8080';
